<template>
  <div class="right-box">
    <div class="right-header">
      <b>{{kidName}} > 回收站</b>
      <div style="float:right;display: flex;align-items: center;">
        <div style="margin-right: 10px;">
          <el-input placeholder="请输入搜索信息" v-model="keyword" class="input-with-select header-input">
            <el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="right-box-content">
      <div class="left-list">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            label="名称"
          >
            <template slot-scope="scope">
              <i class="nameIcon iconfont iconfolder" style="color:#f1e531" v-if="scope.row.type===2"></i>
              <i class="nameIcon iconfont iconfile_word" style="color: #2677dc"
                 v-else-if="scope.row.type===1 && (scope.row.typeName === 'doc' || scope.row.typeName === 'dox')"></i>
              <i class="nameIcon iconfont iconfile_excel" style="color: #27e239"
                 v-else-if="scope.row.type===1 && (scope.row.typeName === 'xls' || scope.row.typeName === 'xlsx')"></i>
              <i class="nameIcon iconfont iconfile_ppt" style="color: #e4393c"
                 v-else-if="scope.row.type===1 && (scope.row.typeName === 'ppt' || scope.row.typeName === 'pptx')"></i>
              <i class="nameIcon iconfont iconfile_pdf" style="color: #d50000"
                 v-else-if="scope.row.type===1 && scope.row.typeName === 'pdf'"></i>
              <i class="nameIcon iconfont iconfile_img" style="color: #27e239"
                 v-else-if="scope.row.type===1 && (scope.row.typeName === 'jpg' || scope.row.typeName === 'png'|| scope.row.typeName === 'bmp'|| scope.row.typeName === 'gif'|| scope.row.typeName === 'jpeg')"></i>
              <i class="nameIcon iconfont iconfile_zip" style="color: #E23E22" v-else></i>
              {{ scope.row.label}}
            </template>
          </el-table-column>
          <el-table-column
            prop="lastuname"
            label="操作人"
          >
          </el-table-column>
          <el-table-column
            prop="addtime"
            label="操作时间"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="set-btn" style="color: #0a2240" @click="huifuFile(scope.row.id)">恢复</span>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        kidName: '',       //  知识库名称
        tableData: [],     //  资源数据
        keyword:'',
        loading: null
      }
    },
    created() {
      this.kidName = this.$route.query.name
      this.getList()
      this.$store.state.upTree = true
    },
    methods: {
      toSearch(){

        if(!this.keyword) return
        this.$router.push({
          path:'/home/repositoriesSearch/' + this.keyword,
        })
      },
      //  恢复文件
      huifuFile(id) {
        this.$confirm('确定要恢复文件吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning'
        }).then(() => {
          this.$api.apiContent.regain({
            mid: this.$store.state.userMid,
            username: this.$store.state.userName,
            ids: [id]
          }).then((res) => {
            this.$message.success(res.msg)
            this.getList()
            this.$store.state.upTree = true
          }).catch(e => {
            this.$message.error(e.msg)
          })
        }).catch();
      },
      //  获取当前文件夹资源
      getList() {
        this.$api.apiContent.Recycled({
          mid: this.$store.state.userMid,
          kid: this.$route.query.id,
        }).then(res => {
          if (res.data) {
            res.data.map(item => {
              if (item.type === 1) {
                item.typeName = item.label.split(".").pop()
              }
              item.addtime = this.$tools.ZHDate(new Date(item.addtime * 1000), 1)
            })
            this.tableData = res.data
          }
        }).catch(e => {
          console.log(e)
          this.tableData = []
        })
      },
      huifu(id) {
        console.log(id)
        this.getList()
      }
    },
    watch: {
      '$route': 'setName'
    }
  }
</script>

<style scoped lang="scss">
  .right-box {
    .right-header {
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #ddd;
      padding: 0 20px;

      b {
        font-size: 18px;
        padding-right: 5px;
      }
    }

    .right-box-content {
      display: flex;

      .left-list {
        flex: 1;
        padding: 0 20px;

        .nameIcon {
          font-size: 24px;
          position: relative;
          top: 2px;
        }

        .set-btn {
          margin-right: 20px;
          cursor: pointer;
        }

        .upload-pic {
          padding: 100px 0;
        }

        .up-text {
          padding: 50px;

          h3 {
            font-size: 24px;
            text-align: center;
            line-height: 60px;
            color: #666;
          }

          p {
            line-height: 40px;
            color: #999;
          }
        }
      }

      .right-set {
        width: 250px;
        padding: 25px;

      }
    }
  }
</style>